export default "__VITE_ASSET__BFJ83NbB__"